import React from "react";
import { observer } from "mobx-react";

import { BetBuilderPick } from "@data-types/bet-booster/BetBuilderPicks";
import { analyticsTracker } from "@utils/analytics";
import { BetBuilderPickActionsTypeEnum } from "@data-types/analytics-tracker/QuickPlayInteractionTypeEnum";
import BetBuilderPicksEventCard from "./BetBuilderPicksEventCard";

export default observer(function BetBuilderPicksEventSliderItem(props: {
	BBPick: BetBuilderPick;
	index: number;
	isDragging: boolean;
	activatePopup: (id: string, index: number, show: boolean) => void;
}) {
	const handleClick = (e: React.MouseEvent) => {
		e.stopPropagation();
		e.preventDefault();
		if (props.isDragging) {
			return null;
		}

		analyticsTracker.trackQuickPlayInteraction(
			BetBuilderPickActionsTypeEnum.PickClick
		);

		props.activatePopup(props.BBPick.id, props.index, false);
	};

	return (
		<div
			onClick={handleClick}
			className="carousel__slide carousel--most__slide"
		>
			<div className="card card--qp card--qp--borderless card--qp--nowrap card--bbp card--bbp--nowrap">
				<div className="card--qp__body card--bbp__body">
					<BetBuilderPicksEventCard
						BBPick={props.BBPick}
						maxOffers={2}
					/>
				</div>
			</div>
		</div>
	);
});
